import { carrierTypes, shipStationCarrierTypes } from 'common/constants';
import _ from 'lodash';

// True when ShipStation can quote the carrier service, i.e. when it is worth offering on a ShipStation
// channel. Needs the carrier service's carrierType embedded.
export default function isShipStationCarrierService(carrierService) {
	const carrierTypeName = _.get(carrierService, 'carrierType.name');
	if (!_.includes(shipStationCarrierTypes, carrierTypeName)) {
		return false;
	}
	if (carrierTypeName !== carrierTypes.usps) {
		return true;
	}
	// ShipStation quotes USPS once per packaging ("USPS Priority Mail - Flat Rate Envelope"), separately priced,
	// and never as the bare service - so a USPS service that names no packaging can never come back on a rate.
	// The packaging is the text after the last " - ", which is how the rate fetch reads it off the ShipStation
	// service name too.
	const name = _.get(carrierService, 'name') || '';
	const separatorIndex = name.lastIndexOf(' - ');
	return separatorIndex > 0 && name.slice(separatorIndex + 3).trim() !== '';
}
